import { CreateFormObject } from "@pdfking/forms"
import type { JobProcessor, MaterialEntry } from "@pdfking/imposition/internal"
import { imposition_fields, LoadFormat } from "@pdfking/imposition/internal"

import type { CustomConfig } from "#public"

import { ValidateBookInteriorDuplex } from "../validators/ValidateBookInteriorDuplex"
import { ValidateBookSignatures } from "../validators/ValidateBookSignatures"
import { ValidateHorizonStructure } from "../validators/ValidateHorizonStructure"
import { ValidateImpositionSizes } from "../validators/ValidateImpositionSizes"
import { ValidateJobProcessors } from "../validators/ValidateJobProcessors"
import { ValidateLastJobPrints } from "../validators/ValidateLastJobPrints"

/** What the imposition form is built with: the host's config, and the
 * markings and materials it offers. */
export type ImpositionFormConfig = Partial<CustomConfig> & {
  hooks_list?: Record<string, JobProcessor>
  material_list?: MaterialEntry[]
}

/** Build the imposition form with localized choice labels (loads i18n first). */
export const ImpositionSchemaForm = async ({
  language = "en",
  material_list = [],
  size_suggestions,
  machine_size_suggestions,
  hooks_list,
}: ImpositionFormConfig = {}) => {
  const { format_entity: format } = await LoadFormat(language)

  return CreateFormObject(
    imposition_fields(
      format,
      material_list,
      size_suggestions,
      machine_size_suggestions,
      hooks_list
    ),
    {
      validators: [
        ValidateJobProcessors,
        ValidateHorizonStructure,
        ValidateImpositionSizes,
        ValidateBookSignatures,
        ValidateBookInteriorDuplex,
        ValidateLastJobPrints,
      ],
    }
  )
}

/** The file pass-through preset's form: it imposes nothing, so the job's name
 * is all it carries. */
export const FilesPresetForm = async ({ language = "en" }: Partial<CustomConfig> = {}) => {
  const { format_entity: format } = await LoadFormat(language)

  return CreateFormObject({ filename: imposition_fields(format).filename })
}
